module.exports = __webpack_public_path__ + "eg.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/eg.svg
// module id = 532
// module chunks = 0